import ConfigurationDocsFeature from '../../features/docs/configuration-feature';

export default function ConfigurationDocsPage() {
  return <ConfigurationDocsFeature />;
}
